import React, { memo, useEffect, useState } from 'react';
import { getPath } from "../route-utils.js";
import { NotAuthenticated } from "./not-authenticated.js";
import { NotAuthorized } from "./not-authorized.js";
import { SilentCallback } from "./silent-callback.js";
const OidcRoutesComponent = ({
  notAuthenticated = /*#__PURE__*/React.createElement(NotAuthenticated, null),
  notAuthorized = /*#__PURE__*/React.createElement(NotAuthorized, null),
  callbackComponent,
  sessionLost,
  configuration,
  children
}) => {
  const [path, setPath] = useState(window.location.pathname);
  const setNewPath = () => setPath(window.location.pathname);
  useEffect(() => {
    setNewPath();
    window.addEventListener('popstate', setNewPath, false);
    return () => window.removeEventListener('popstate', setNewPath, false);
  });
  const silentCallbackPath = getPath(configuration.silent_redirect_uri);
  const callbackPath = getPath(configuration.redirect_uri);
  switch (path) {
    case callbackPath:
      return /*#__PURE__*/React.createElement(React.Fragment, null, callbackComponent);
    case silentCallbackPath:
      return /*#__PURE__*/React.createElement(SilentCallback, null);
    case '/authentication/not-authenticated':
      return /*#__PURE__*/React.createElement(React.Fragment, null, notAuthenticated);
    case '/authentication/not-authorized':
      return /*#__PURE__*/React.createElement(React.Fragment, null, notAuthorized);
    case '/authentication/session-lost':
      return /*#__PURE__*/React.createElement(React.Fragment, null, sessionLost);
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
};
export const OidcRoutes = /*#__PURE__*/memo(OidcRoutesComponent);
//# sourceMappingURL=oidc-routes.js.map